import React from 'react';
import { AlertInlineMain, SuggestionObject } from '@inmoment/the-kitchen';
import { Row } from '../cookbook-ui/custom-components/Table/Table';

export const HOME_PAGE_TEXT = {
  mainDisplay: {
    headingText: 'The XI Kitchen',
    bodyText: 'A system of visuals to make XI truly unique.',
  },
};
export const hasChildren = ['List', 'GenericModal', 'BasicTile', 'Drawer', 'Accordion', 'SidePanel', 'AppTitleBar', 'AppSideDisplay'];

export const page = 'Page';
export const FAQ = 'FAQ';
export const graphics = 'graphics';
export const template = 'Template';

export const otherSearchablePages: SuggestionObject[] = [
  {
    text: `Reference App – ${template}`,
    id: template,
  },
  {
    text: `Kitchen Starter – ${template}`,
    id: template,
  },
  {
    text: `SVGs – Graphics`,
    id: graphics,
  },
  {
    text: `Graphics – Graphics – ${page}`,
    id: graphics,
  },
  {
    text: `Animations – Graphics`,
    id: graphics,
  },
  {
    text: `Illustrations – Graphics`,
    id: graphics,
  },
  {
    text: `InMoment Logos – Graphics`,
    id: graphics,
  },
  {
    text: `Skewmorphics – Graphics`,
    id: graphics,
  },
  {
    text: `Visual Demos – Graphics`,
    id: graphics,
  },
  {
    text: `Sentiments – Graphics`,
    id: graphics,
  },
  {
    text: `Backgrounds – Graphics`,
    id: graphics,
  },
  {
    text: `Company Logos – Graphics`,
    id: graphics,
  },
  {
    text: `Misc SVGs – Graphics`,
    id: graphics,
  },
  {
    text: `Children / Transclusion Usage - ${FAQ} – ${page}`,
    id: FAQ,
  },
  {
    text: `How do I use 2 way binding? - ${FAQ} – ${page}`,
    id: FAQ,
  },
  {
    text: `How do I install the Kitchen - ${FAQ} – ${page}`,
    id: FAQ,
  },
  {
    text: `Children / Transclusion Usage - ${FAQ} – ${page}`,
    id: FAQ,
  },
  {
    text: `Updates – ${page}`,
    id: page,
  },
  {
    text: `Upcoming Breaking Changes – ${page}`,
    id: page,
  },
  {
    text: `Updates – ${page}`,
    id: page,
  },
  {
    text: `Metrics – ${page}`,
    id: page,
  },
  {
    text: `Typography – Visuals – ${page}`,
    id: page,
  },
  {
    text: `Shadows – Visuals – ${page}`,
    id: page,
  },
  {
    text: `Colors – Visuals – ${page}`,
    id: page,
  },
  {
    text: `Icons – Visuals – ${page}`,
    id: page,
  },
];

export const errorObjectTextType = 'ErrorObject | null';
export const errorStatesTextType = 'ErrorStates | null';

export const ALPHABET = 'Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj Kk Ll Mm Nn Oo Pp Qq Rr Ss Tt Uu Vv Ww Xx Zz';

export const TYPOGRAPHY_TABLE_ROWS: Row[] = [
  ['small', '12px ', '0.75', 'Small'],
  ['body', '14px', '0.875', 'Body'],
  [1, '16px', '1', 'Size_1'],
  [2, '18px', '1.125', 'Size_2'],
  [3, '20px', '1.25', 'Size_3'],
  [4, '24px', '1.5', 'Size_4'],
  [5, '28px', '1.75', 'Size_5'],
  [6, '32px', '2', 'Size_6'],
  [7, '36px', '2.25', 'Size_7'],
  [8, '42px', '2.625', 'Size_8'],
  [9, '48px', '3', 'Size_9'],
  [10, '54px', '3.375', 'Size_10'],
  [11, '60px', '3.75', 'Size_11'],
  [12, '68px', '4.25', 'Size_12'],
  [13, '76px', '4.75', 'Size_13'],
  [14, '84px', '5.25', 'Size_14'],
  [15, '92px', '5.75', 'Size_15'],
];
export const TYPOGRAPHY_TABLE_COLUMNS = ['Name', 'Size', 'Line Height', 'Example'] as const;
export const CLASS_PROP_COLUMNS = ['Name', 'Interface / Type', 'Accepted Values', 'Default', 'Description', 'Required'] as const;
export const INTERFACE_PROP_COLUMNS = ['Name', 'Interface / Type', 'Accepted Values', 'Description', 'Required'] as const; // no default

export type PageType = 'Playground' | 'React' | 'Web' | 'Angular';
export const TABS: { title: string; id: PageType }[] = [
  { title: 'Playground', id: 'Playground' },
  { title: 'React Code', id: 'React' },
  { title: 'Web Component Code', id: 'Web' },
  { title: 'Angular HTML', id: 'Angular' },
];

export const DISALLOWED_PROPS = [
  '_controlledState',
  '_linkHex',
  'activeAccountId',
  'activeLink',
  'activeProgramId',
  'allowPropagation',
  'answerId',
  'audioSrcUrl',
  'availableLoaderSettings',
  'category',
  'chartSettings',
  'children',
  'comments',
  'componentDescription',
  'componentName',
  'container',
  'contextData',
  'dangerouslySetInnerHTML',
  'data',
  'direction',
  'dropdownData',
  'elementsToDisableScroll',
  'extends',
  'externalId',
  'footerButton',
  'fullScreen',
  'groups',
  'hasPortal',
  'highlightedCommentId',
  'hoverShadow',
  'iconButtons',
  'inputId',
  'interceptClose',
  'interceptOpen',
  'internalProps',
  'isFiredOnEnter',
  'isLeftDefault',
  'isVisible',
  'leftPadding',
  'link',
  'linkColor',
  'links',
  'locale',
  'localization',
  'maxDate',
  'maxSuggestions',
  'meta',
  'minDate',
  'name',
  'normalShadow',
  'notesData',
  'onCancelClick',
  'onChangeOverride',
  'open',
  'prePopulateStatus',
  'pressedShadow',
  'radioClass',
  'ref',
  'selectedLoaderSettings',
  'sentimentBarExpanded',
  'showMoreMomentsLink',
  'source',
  'state',
  'stretch',
  'style',
  'tabSpacing',
  'tooltip',
  'value',
  'wrap',
  'wrapperProps',
];
export const DISALLOWED_PROP_TYPES = ['number | [number, number] | []'];
export const SHADOW_COLUMNS = ['Level', 'Shadow', 'Value', 'Description'];

export const SHADOW_DESCRIPTIONS = [
  'Opacity is 0. Typically will be used for animating.',
  'Used on buttons and other elements that are just slightly above the page.',
  'Standard Hover Effect.',
  'Used for a more dramatic hover effect.',
  '',
  '',
  '',
  'Used for maximum elevation. Such as modals or overlays that require action.',
];

export const COMPLEX_COMPONENTS = ['ListItem'];

interface DeprecateAlertProps {
  name: string;
  rename?: string;
}
export const DeprecateAlert = ({ name, rename }: DeprecateAlertProps) => {
  const action = rename ? `renamed to ${rename}` : `removed`;
  const subtitle = `Note: In v15 the component ${name} will be ${action}.`;
  return <AlertInlineMain color="warning" title="Deprecation Notice" subtitle={subtitle} />;
};
